import React from "react"
import { useDispatch, useSelector } from "react-redux"

import {
  getFilteredPortAwardSetTotal,
  getCostAnalysis,
  getProductAwardSetTotal,
  portExpanded,
} from "@/onboarding/features/cost_analysis/selectors"
import { expandPort, minimizePort } from "@/onboarding/features/cost_analysis/Slice"
import { formatMoney } from "@/helpers/money"
import routes from "@/routes"

const PortAwardSetTotal = ({ filteredPortProducts, awardSetId }): JSX.Element => {
  const { amount, netCurrencyCode: currency } = useSelector(
    getFilteredPortAwardSetTotal(filteredPortProducts)(awardSetId)
  )

  // TODO Return green or red text based on minimum/maximum in the row
  return <>{formatMoney(amount, currency)}</>
}

const ProductAwardSetTotal = ({ productId, awardSetId }): JSX.Element => {
  const { amount, netCurrencyCode: currency } = useSelector(
    getProductAwardSetTotal(productId)(awardSetId)
  )

  // TODO Return green or red text based on minimum/maximum in the row
  return <>{formatMoney(amount, currency)}</>
}

const PortRow = ({ port, awardSets, selectedAwardSetId }): JSX.Element => {
  const dispatch = useDispatch()
  const selected = useSelector(portExpanded(port.id))
  const { selectedCruiseBrandId, selectedOperatorId } = useSelector(getCostAnalysis)

  const filteredPortProducts = port.products.filter((product) => {
    const matchesCruiseBrand =
      !selectedCruiseBrandId ||
      product.cruiseBrands.some((brand) => brand.id === selectedCruiseBrandId)

    const matchesOperator =
      !selectedOperatorId ||
      product.biddingOperators.some((operator) => operator.id === selectedOperatorId)

    return matchesCruiseBrand && matchesOperator
  })

  const onClick = selected
    ? () => dispatch(minimizePort())
    : () => dispatch(expandPort({ portId: port.id }))

  const cellClass = (awardSetId) =>
    awardSetId === selectedAwardSetId ? "text-right bg-secondary" : "text-right"

  let row

  if (port.products.length > 0) {
    row = (
      <tr className="cursor-pointer" onClick={onClick}>
        <th scope="row">
          {`${port.name} `}
          <span className="badge bg-primary">{filteredPortProducts.length}</span>
        </th>
        <td />
        {awardSets.map(({ id }) => (
          <td key={id} className={cellClass(id)}>
            <PortAwardSetTotal filteredPortProducts={filteredPortProducts} awardSetId={id} />
          </td>
        ))}
      </tr>
    )
  } else {
    row = (
      <tr>
        <th scope="row">{port.name}</th>
        <td />
        {awardSets.map(({ id }) => (
          <td key={id} className={cellClass(id)}>
            <PortAwardSetTotal filteredPortProducts={filteredPortProducts} awardSetId={id} />
          </td>
        ))}
      </tr>
    )
  }

  if (selected) {
    return (
      <>
        {row}
        {filteredPortProducts.map((product) => (
          <tr key={product.id}>
            <th
              scope="row"
              className="text-underline cursor-pointer"
              onClick={() =>
                (window.location = routes.onboarding_product_cost_analysis_path({ id: product.id }))
              }
            >
              <div className="ms-3">{product.code}</div>
            </th>
            <td>{product.name}</td>
            {awardSets.map(({ id }) => (
              <td key={id} className={cellClass(id)}>
                <ProductAwardSetTotal productId={product.id} awardSetId={id} />
              </td>
            ))}
          </tr>
        ))}
      </>
    )
  }

  return row
}

export default PortRow
